import { render } from "./CodingCases.vue?vue&type=template&id=aff1503a"
import script from "./CodingCases.vue?vue&type=script&lang=js"
export * from "./CodingCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/CodingCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aff1503a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aff1503a', __exports__)) {
    console.log('reload')
    api.reload('aff1503a', __exports__)
  }
  
  module.hot.accept("./CodingCases.vue?vue&type=template&id=aff1503a", () => {
    console.log('re-render')
    api.rerender('aff1503a', render)
  })

}


export default __exports__